export default __webpack_public_path__ + "static/media/WhereAreYouFrom_16.5a37426e.png";